import { Button, Form, Input } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { AutoRedirectAfterSubmitSuccessfully } from "../../../../../constants/constants";
import { ROUTE_PATHS } from "../../../../../constants/url-config";
import { ERMService } from "../../../../../services/erm.service";
import { MinusIcon, PlusIcon } from "../../../../atoms/icon";
import AppSubmitedForm from "../../../../atoms/submited-form";
import "./scenrarios-invite.scss";


const ScenrarioInvite = () => {
    const { t } = useTranslation();
    const history = useHistory();
const [sentSuccessfully, setSentSuccessfully] = useState(false);


    const send = (values: { emails: any[] }) => {
        if (!values || !values.emails) {
            return;
        }

        const emails = values.emails.map(x => x.email)

        ERMService.scenarioInviteAsync(emails).then(res => {
            setSentSuccessfully(true);
            setTimeout(()=> {
                history.push(ROUTE_PATHS.Scenarios);
            }, AutoRedirectAfterSubmitSuccessfully)

        })
    }

    return sentSuccessfully ? <AppSubmitedForm title="Email has been sent" /> : (
        <Form
            name="assessmentForm"
            layout="vertical"
            onFinish={send}
            initialValues={{ emails: [""] }}
            className="main-card scenrarios-assessment-wrapper">
            <div>
                <div className="title">
                    {t("ScenrariosAssessment.title")}
                </div>
                <Form.List
                    name="emails"
                >

                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map((field, index) => (
                                <Form.Item
                                    key={field.key}
                                    label={index === 0 ?
                                        <>{t("ScenrariosAssessment.lbEmail")}&nbsp;
                                            <small>
                                                {t("ScenrariosAssessment.emailDes")}
                                            </small> </> : null}
                                >
                                    <Form.Item
                                        {...field}
                                        rules={[
                                            { required: true, message: "" },
                                            { type: 'email', message: "" },
                                        ]}
                                        name={[field.name, "email"]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <span>
                                        <PlusIcon className={`list-item-icon ${fields.length >= 5 ? 'disabled' : ''}`} onClick={() => {
                                            if (fields.length < 5) {
                                                add();
                                            }
                                        }} />
                                    </span>
                                    <span>
                                        {
                                            index > 0 && <MinusIcon onClick={() => { remove(field.name) }} />
                                        }
                                    </span>
                                </Form.Item>
                            ))}

                        </>
                    )}
                </Form.List>
            </div>


            <Button htmlType="submit" className="action" type="primary" shape="round" block>{t("ScenrariosAssessment.btnSend")}</Button>
        </Form>

    )
}

export default ScenrarioInvite